import extendNode from '../extendNode.mjs'
import useCatRootModuleNode from '../_CAT_ROOT_MODULE/useCatRootModuleNode.jsx'
import PropertiesPane from './PropertiesPaneCatRootBm.jsx'
import meta from './metaCatRootBm.mjs'

export default () => {
    const CatRootModuleNode = useCatRootModuleNode()

    return extendNode(CatRootModuleNode, {
        ...meta,
        PropertiesPane,

        canLinkType(map, node, type) {
            const {prjTypeCode, subTypeCode} = map.data

            if (
                'BM' === prjTypeCode ||
                'BODA2' === subTypeCode
            ) {
                return /^(BD|UI)$/.test(type)
            }
            else {
                return /^(BD|BF)$/.test(type)
            }
        },

        defaultChildType(map, node) {
            const {prjTypeCode, subTypeCode} = map.data

            if (
                'BM' === prjTypeCode ||
                'BODA2' === subTypeCode
            ) {
                return 'UI'
            }
            else {
                return 'BF'
            }
        },

        menuItemsInsertConcept(map, node) {
            const {prjTypeCode, subTypeCode} = map.data

            if (
                'BM' === prjTypeCode ||
                'BODA2' === subTypeCode
            ) {
                return [
                    {type: 'BD'},
                    {type: 'UI'},
                ]
            }
            else {
                return [
                    {type: 'BD'},
                    {type: 'BF'},
                ]
            }
        },

        menuItemsInsertProduct(map, node) {
            const {prjTypeCode, subTypeCode} = map.data

            if (
                'BM' === prjTypeCode ||
                'BODA2' === subTypeCode
            ) {
                return [
                    {type: 'BD'},
                    {type: 'UI'},
                ]
            }
            else {
                return [
                    {type: 'BD'},
                    {type: 'BF'},
                ]
            }
        },
    })
}
